export default "__VITE_ASSET__CfifF7zW__"